export const WEEK_NAMES: string[] = ['日', '月', '火', '水', '木', '金', '土'];

// 月曜開始版.
export const MON_START_WEEK_NAMES: string[] = ['月', '火', '水', '木', '金', '土', '日'];
